// **********************************************************
// Main Products Slider
// **********************************************************

const mainProductsSlider = document.querySelectorAll('[data-slider="main-products-slider"]');

const mainProductsSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar',
  },
  breakpoints: {
    767: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
};

const initMainProductsSlider = (el) => {
  const parentEle = el.closest('.main-products');

  const arrowRight = parentEle.querySelector('.arrow-right');
  const arrowLeft = parentEle.querySelector('.arrow-left');
  const pagination = parentEle.querySelector('.swiper-pagination');

  const options = {
    ...mainProductsSliderOptions,
    pagination: {
      ...mainProductsSliderOptions.pagination,
      el: pagination,
    },
    navigation: {
      prevEl: arrowLeft,
      nextEl: arrowRight,
    },
  };

  new Swiper(el, options);
};

mainProductsSlider.forEach((el) => initMainProductsSlider(el));

setupResponsiveSliders({
  sliderElements: mainProductsSlider,
  breakpoint: breakpointSm,
  initSlider: initMainProductsSlider,
  mobileFallback: [enableProgressSync, enableArrowScrollSync],
  parentSelector: '[data-slider-parent]',
});
